import React from "react";

import styles from "./EditPenButton.module.css";

export type EditPenButtonProps = React.HTMLAttributes<HTMLButtonElement>;

export const EditPenButtonUI: React.FC<EditPenButtonProps> = (props) => {
  return <button className={styles.editPenButton} {...props}></button>;
};
